import React from 'react';
import { X } from 'lucide-react';

const Impressum = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose} />
      
      {/* Modal */}
      <div className="relative bg-gray-900 rounded-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto border border-gray-700 shadow-2xl">
        {/* Header */}
        <div className="sticky top-0 bg-gray-900 border-b border-gray-700 p-6 flex justify-between items-center">
          <h2 className="text-2xl font-bold bg-gradient-to-r from-cyan-400 to-amber-500 bg-clip-text text-transparent">
            Impressum & Rechtliches
          </h2>
          <button
            onClick={onClose}
            className="p-2 rounded-lg hover:bg-gray-800 transition-colors"
          >
            <X className="w-6 h-6" />
          </button>
        </div>
        
        {/* Content */}
        <div className="p-6 space-y-8 text-gray-300">
          {/* Haftungsausschluss */}
          <section>
            <h3 className="text-xl font-semibold text-white mb-4">RECHTLICHER HAFTUNGSAUSSCHLUSS</h3>
            <p className="text-sm leading-relaxed mb-4">
              Die Lazzaro One UG (haftungsbeschränkt) bietet ihren Kunden und Besuchern ausschließlich 
              Beratungsleistungen im landwirtschaftlichen und technologischen Kontext an. Wir verstehen 
              uns nicht als Finanzberater, Anlageexperten oder rechtliche Berater. Sämtliche von uns 
              bereitgestellten Informationen, Analysen, Prognosen und Handlungsempfehlungen zielen darauf ab, 
              landwirtschaftliche Prozesse und technologische Abläufe zu optimieren, betriebliche 
              Entscheidungen im Agrarbereich zu unterstützen oder technologische Einsatzmöglichkeiten aufzuzeigen.
            </p>
            <p className="text-sm leading-relaxed mb-4">
              Insbesondere stellen unsere Inhalte weder eine Anlageempfehlung noch eine Aufforderung zum 
              Kauf, Verkauf oder Halten von Wertpapieren, Finanzinstrumenten oder sonstigen Kapitalanlagen dar. 
              Wir übernehmen keine Verantwortung für finanzielle Entscheidungen, die auf Grundlage unserer 
              Informationen getroffen werden. Jede Investitions- oder Finanzierungsentscheidung sollte stets 
              unter Hinzuziehung eines qualifizierten Finanzberaters oder einer anderen fachkundigen Stelle erfolgen.
            </p>
            <p className="text-sm leading-relaxed">
              Bitte beachten Sie, dass alle auf dieser Webseite oder in unseren Reports bereitgestellten 
              Informationen ohne Gewähr erfolgen. Obwohl wir uns bemühen, verlässliche und sorgfältig 
              recherchierte Inhalte bereitzustellen, übernehmen wir keine Haftung für Aktualität, 
              Vollständigkeit oder Richtigkeit der bereitgestellten Informationen. Rechtliche und finanzielle 
              Fragestellungen müssen individuell geprüft werden. Für eine rechtliche oder finanzielle Beratung 
              ist ein entsprechender Fachanwalt, Steuerberater oder Finanzexperte hinzuzuziehen.
            </p>
          </section>

          {/* Impressum */}
          <section>
            <h3 className="text-xl font-semibold text-white mb-4">IMPRESSUM - DIE GRUNDLAGEN</h3>
            <div className="space-y-3 text-sm">
              <div>
                <p className="font-semibold text-white">Lazzaro One UG (haftungsbeschränkt)</p>
                <p>Forckenbeckstraße 63c</p>
                <p>14199 Berlin</p>
                <p>Deutschland</p>
              </div>
              
              <div>
                <p className="font-semibold text-white">Vertreten durch:</p>
                <p>Arsenio Longo (Geschäftsführer)</p>
              </div>
              
              <div>
                <p className="font-semibold text-white">Kontakt:</p>
                <p>Telefon: <a href="tel:+493024618457" className="text-cyan-400 hover:underline">+49 (0)30 24618457</a></p>
                <p>E-Mail: <a href="mailto:office@lazzaro.one" className="text-cyan-400 hover:underline">office@lazzaro.one</a></p>
              </div>
              
              <div>
                <p className="font-semibold text-white">Registereintrag:</p>
                <p>Eintragung im Handelsregister</p>
                <p>Registergericht: Amtsgericht Charlottenburg</p>
                <p>Registernummer: HRB 264590 B</p>
              </div>
              
              <div>
                <p className="font-semibold text-white">Umsatzsteuer-Identifikationsnummer:</p>
                <p>gemäß § 27a UStG: DE368386682</p>
              </div>
              
              <div>
                <p className="font-semibold text-white">Inhaltlich verantwortlich gemäß § 55 RStV:</p>
                <p>Arsenio Longo</p>
                <p>Forckenbeckstraße 63c</p>
                <p>14199 Berlin</p>
              </div>
              
              <div>
                <p className="font-semibold text-white">Erlaubnisbehörde:</p>
                <p>Gewerbeamt Berlin Charlottenburg-Wilmersdorf</p>
              </div>
              
              <div>
                <p className="font-semibold text-white">Angaben zur Online-Streitbeilegung:</p>
                <p className="leading-relaxed">
                  Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit, 
                  die Sie unter <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" 
                  className="text-cyan-400 hover:underline">https://ec.europa.eu/consumers/odr</a> finden. 
                  Unsere E-Mail-Adresse lautet: office@lazzaro.one
                </p>
              </div>
              
              <div className="pt-4 border-t border-gray-700">
                <p className="font-semibold text-white">Hinweis:</p>
                <p className="leading-relaxed">
                  Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer 
                  Verbraucherschlichtungsstelle teilzunehmen.
                </p>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Impressum;